import { TextField } from "@mui/material";
import React from "react";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
 
const CommonDateTimePicker = ({
    name,
    size,
    label,
    pickerFormat,
    DefaultDTvalue,
    handleChange,
    openTo,
    views = ["year", "month", "day", "hours", "minutes"],
    error,
    helperText,
    variant,
    maxDate,
    minDate,
    disableDates,
    disabled,
    required,
    inputReadOnly = true,
    onKeyPress,
    onKeyDown,
    textFieldSx,
}) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
                {...(openTo && {
                    openTo: openTo,
                })}
                views={views}
                shouldDisableDate={disableDates}
                minDate={minDate}
                maxDate={maxDate}
                name={name}
                label={label}
                inputFormat={pickerFormat}
                value={DefaultDTvalue}
                onChange={handleChange}
                disabled={disabled}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant={variant}
                        onKeyDown={onKeyDown}
                        onKeyPress={onKeyPress}
                        disabled={disabled}
                        size={size}
                        error={error}
                        required={required}
                        helperText={helperText}
                        sx={textFieldSx}
                        {...(textFieldSx?.isPreRegistration && {
                            InputProps: {
                                ...params.InputProps,
                                disableUnderline: true,
                                sx: {
                                    "& .MuiSvgIcon-root": {
                                        fontSize: "30px",
                                    },
                                },
                            },
                        })}
                        inputProps={{ ...params.inputProps, readOnly: inputReadOnly }}
                    />
                )}
            />
        </LocalizationProvider>
    );
};
 
export default CommonDateTimePicker;